export function addCurrent(customer) {
    return {
        type: 'ADD_CURRENT_CUSTOMER',
        customer,
    }
}